<template>
  <div class="bancos-cuentas-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          nombreLeyenda="Nro de Cuenta"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Cuentas">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="bancosCuentas" 
              :fields="bancosCuentasFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown
                  v-if="!data.item.readonly"
                  variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos de la Cuenta</b-dropdown-item>
                <b-dropdown-item @click.stop="actualizarCierre(data.item)">
                  <i class="fa fa-lock"></i>Actualizar cierre</b-dropdown-item>
                <b-dropdown-item @click.stop="saldoCuenta(data.item)">
                  <i class="fa fa-exchange"></i>Consultar Saldo de la Cuenta</b-dropdown-item>
                <b-dropdown-item @click.stop="inactivar(data.item)">
                  <i class="fa fa-remove"></i>Inactivar Cuenta</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancoscuentas/getField',
  mutationType: 'bancoscuentas/updateField',
});

export default {
  name: 'BancosCuentasList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      bancosCuentasFields: [
        {
          key: 'banco',
          sortable: true
        },
        {
          key: 'moneda'        
        },
        {
          key: 'cuentaNumero',
          sortable: true
        },
        { key: 'cbu' },
        { key: 'cbuAlias' },
        { 
          key: 'inactivo',
          class: 'text-center', 
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
      bancoCuentaSeleccionada: {},
    }
  },
  computed: {
    ...mapFields([
      'bancosCuentas',
      'nombre',
      'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getBancosCuentas();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getBancosCuentas();
    },
    getBancosCuentas() {
      this.tableBusy = true;
      this.$store.dispatch('bancoscuentas/getBancosCuentas')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'BancoCuentaData', 
                          params: { id: item.id }});
    },
    editar (item) {
      this.$router.push({ name: 'BancoCuentaABM', 
                          params: { id: item.id }});
    },
    actualizarCierre (item) {
      this.$router.push({ name: 'BancoCuentaCierre', 
                          params: { id: item.id }});
    },
    saldoCuenta (item) {
      this.$router.push({ name: 'BancoCuentaSaldos', 
                          params: { id: item.id }});
    },
    inactivar (item) {
      this.showModalConfirm('¿Desea inactivar la cuenta seleccionada?', 
            this.inactivarCuenta.bind(this, item), 'Si', null, 'No')
    },
    agregar () {
      this.$router.push({ name: 'BancoCuentaABM', 
                          params: { id: 0 }});
    },
    inactivarCuenta (bancoCuenta) {
      this.showSpinner();
      this.$store.dispatch('bancoscuentas/delete', bancoCuenta.id)
        .then(() => this.showModalMsj('La cuenta se inactivó con éxito.', this.getBancosCuentas, this.getBancosCuentas, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getBancosCuentas();
      }
    },    
  }    
}
</script>

<style>
  .bancos-cuentas-list .registro table tr.table-read-only {
    color: rgba(35, 40, 44, 0.6);
  }
</style>
